import { ControlValueAccessor } from '@angular/forms';

export class BaseValueAccessor<T> implements ControlValueAccessor {

  protected innerValue: T;

  protected changed = (value: T) => {
  };
  protected touched = () => {
  };

  writeValue(value: T): void {
    this.innerValue = value;
  }

  registerOnChange(fn: (value: T) => void): void {
    this.changed = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.touched = fn;
  }

}
